import { LinkTo } from "../../CommonComponents/commonStyles";
import styled from "styled-components";

export const HyperLinkComponentt = styled(LinkTo)`
  color: ${props => props.test && 'red'} blue !important;
`;

export const NotWebRegister = styled.div`
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.thead};
  background-color: ${props => props.theme.backgroundColor.oleGeminiColor};
  padding: 10px;
  width: 300px;
`;